import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArmchair: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArmchair"><Path d="M5 11V3H19V11H16V13.5H8V11H5Z" fill="currentColor"/><Path d="M3 12.5V19H5V21H6.5V19H17.5V21H19V19H21V12.5H17.5V15H6.5V12.5H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArmchair;
